import { QueryClient } from '@tanstack/react-query';

/**
 * Single shared QueryClient.
 *
 * Defaults are tuned for the read-heavy public surface:
 *   - data freshness is acceptable for several minutes (sync runs daily),
 *     so a generous staleTime keeps the globe + drawer snappy on tab switch.
 *   - we never refetch on window focus — the globe is the centerpiece,
 *     refetches would re-trigger expensive marker layouts.
 *   - errors should not noisily retry; the API surfaces ErrorState UIs that
 *     give the user the retry control.
 *
 * Per-query overrides (e.g. globe points use staleTime: 5min) live next to
 * the hook that owns the query (`useGlobeData.ts`).
 */
export function createQueryClient(): QueryClient {
  return new QueryClient({
    defaultOptions: {
      queries: {
        staleTime: 60 * 1000,
        gcTime: 10 * 60 * 1000,
        retry: 1,
        refetchOnWindowFocus: false,
        refetchOnReconnect: 'always',
      },
      mutations: {
        retry: 0,
      },
    },
  });
}
